import React,{forwardRef} from 'react'
import ProductForm from './ProductForm'

const AddProduct = forwardRef((props, ref) => {
    const {
        productSave, 
        updateProductList, 
        formValidateError,
        isProductSubmitted,
        isButtonLoader
    } = props;
    return (
        <>
            <ProductForm
                productSave={productSave}
                updateProductList={updateProductList}
                formValidateError={formValidateError}
                formActionType={'insert'}
                isInfoOpenHandler={props.isInfoOpenHandler}
                isProductSubmitted={isProductSubmitted}
                ref={ref}
                isButtonLoader={isButtonLoader}
            />
        </>
    )
})
export default AddProduct